module.exports = __webpack_public_path__ + "img/hr2_night.568191a.png";